import { UpdateData } from '../tree/nodeUpdates/types'
import React, { useState } from 'react'
import { OperationMetadata, OperationMetadataResponse } from './types'
import { KiddomButtonProps, OutlinedButton } from 'shared/ui'
import { ConfirmDialog } from 'shared/ui'
import { metadataCountItems } from './utility'
import { Table } from 'shared/ui/Table/Table'
import { doTreeOperationsJob, getJobMetadata } from './utility'

export interface OpButtonProps extends Omit<KiddomButtonProps, 'onClick'> {
  operations: UpdateData[]
  onFlowCreated: (flowId: string) => void
  confTitle?: string
  ButtonComp?: React.ComponentType<KiddomButtonProps>
}

export function NodeOperationsConfirmationButton({
  operations,
  onFlowCreated,
  confTitle = 'Do Following Operations',
  disabled,
  ButtonComp = OutlinedButton,
  ...buttonProps
}: OpButtonProps) {
  const [doConfirm, setDoConfirm] = useState(false)
  const [jobMetadata, setJobMetadata] = useState<OperationMetadataResponse>()
  const doGetMetadata = async () => {
    if (!jobMetadata) {
      const meta = await getJobMetadata(operations)
      if (!meta) return
      setJobMetadata(meta)
    }
    setDoConfirm(true)
  }
  const createOperationsFlow = async () => {
    const result = await doTreeOperationsJob(operations)
    const flowId = result.result?.data.flow_id
    setDoConfirm(false)
    if (flowId) onFlowCreated(flowId)
  }
  return (
    <>
      <ButtonComp
        disabled={disabled || !operations.length}
        {...buttonProps}
        onClick={doGetMetadata}
      />
      <ConfirmDialog
        open={doConfirm}
        title={confTitle}
        onClose={() => setDoConfirm(false)}
        onConfirm={createOperationsFlow}
      >
        <MetadataTable operations={jobMetadata?.types} />
      </ConfirmDialog>
    </>
  )
}

function MetadataTable({
  operations,
}: {
  operations: OperationMetadata | undefined
}) {
  if (!operations) return null
  const converted = metadataCountItems(operations)
  const cols = ['type', 'method', 'count'].map((col) => ({
    title: col.toUpperCase(),
    rowContent: (item: Record<string, number | string>) => item[col],
  }))
  return <Table overrideHeight={160} columns={cols} items={converted} />
}
